<template>
  <div style="margin: 0 1em">
    <div style="margin-bottom: 8px;">
      <el-radio-group v-model="hideState" class="ml-4">
        <el-space direction="vertical" alignment="left">
          <el-radio :label="1">全平台隐藏</el-radio>
          <el-radio :label="2">对被屏蔽用户隐藏</el-radio>
          <el-radio :label="0">不隐藏</el-radio>
        </el-space>
      </el-radio-group>
    </div>
    <div class="dialog-footer" style="text-align: left">
      <el-button size="medium" @click="cancel">返 回</el-button>
      <el-button type="primary"  @click="submit" v-loading="loading">确 定</el-button>
    </div>
  </div>
</template>

<script>
import {postFormData} from "@/api/api";
import {updateWeChatHideState} from "@/api/url"

export default {
  name: "VideoPlay",
  props: {
    value: Object
  },
  data() {
    return {
      id: this.value.id,
      loading: false,
      hideState: this.value.hideState,
    }
  },
  methods: {

    //返回
    cancel() {
      // this.carForm = this.value.carForm,
      this.$emit('close');
    },

    //提交
    submit() {
      this.loading = true;
      let _this = this;
      let param = {};
      param['id'] = this.id;
      param['hideState'] = this.hideState;
      postFormData(updateWeChatHideState, param).then(function(data){
        let {code,msg} = data;
        if(code == 200){
          _this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          });
          _this.$emit('confirm', param)
        }else{
          _this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        _this.loading = false;
      })
          .catch(function(response){
            _this.loading = false;
          })
    }

  },
  mounted() {

  }
}
</script>

<style scoped>

</style>
